export default "//cloud.imgsmail.ru/cloud.mail.ru/164372/img/build/quota-landing/googlePlay.png";